<template>
    <div>
        <div class="card-body" v-loading="$parentInfo.studentAdvisory.dialog_ShowAdvisory.loading">
            <el-form ref="$parentInfo.studentAdvisory.dialog_ShowAdvisory.advisoryDetail"
                     :model="$parentInfo.studentAdvisory.dialog_ShowAdvisory.advisoryDetail">
                <el-row :gutter="20">
                    <el-col :span="10">
                        <el-form-item label="年级">
                            <el-select v-model="$parentInfo.studentAdvisory.dialog_ShowAdvisory.advisoryDetail.grade_id"
                                       filterable placeholder="请选择"
                                       style="width: 130px!important;">
                                <el-option
                                        v-for="item in $parentInfo.initInformation.grades"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="10">
                        <el-form-item label="学科">
                            <el-select
                                    v-model="$parentInfo.studentAdvisory.dialog_ShowAdvisory.advisoryDetail.subject_id"
                                    filterable placeholder="请选择"
                                    style="width: 130px!important;">
                                <el-option
                                        v-for="item in $parentInfo.initInformation.subjects"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20" style="margin: 0 0 15px 0"
                        v-if="$parentInfo.studentAdvisory.dialog_ShowAdvisory.advisoryDetail">
                    <el-col :span="20">
                        <el-radio-group
                                v-model="$parentInfo.studentAdvisory.dialog_ShowAdvisory.advisoryDetail.classType_id">
                            <el-radio :label="1">一对一</el-radio>
                            <el-radio :label="2">一对三</el-radio>
                            <el-radio :label="3">小班</el-radio>
                        </el-radio-group>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col align="left" :span="24">
                        <el-form-item label="咨询详情">
                            <el-input
                                    type="textarea"
                                    :rows="3"
                                    placeholder="请输入内容"
                                    v-model="$parentInfo.studentAdvisory.dialog_ShowAdvisory.advisoryDetail.content">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="15">
                        <el-form-item label="印象">
                            <el-rate v-model="$parentInfo.studentAdvisory.dialog_ShowAdvisory.advisoryDetail.impression"
                                     show-score text-color="#ff9900"></el-rate>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="15">
                        <el-form-item label="状态">
                            <el-select v-model="$parentInfo.studentAdvisory.dialog_ShowAdvisory.advisoryDetail.status"
                                       filterable placeholder="请选择">
                                <el-option
                                        v-for="item in $parentInfo.studentAdvisory.dialog_ShowAdvisory.filter.status"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class=" text-right">
            <el-button type="primary" @click="handleUpdateAdvisory()"
                       :loading="$parentInfo.studentAdvisory.dialog_ShowAdvisory.button_loading">修改
            </el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dialog_ShowAdvisory",
        data() {
            return {
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleGetAdvisoryDetail();
        },
        methods: {
            handleGetAdvisoryDetail() {
                this.$wApi.send(this.$parentInfo.path, 'getAdvisoryDetail', {
                    'advisory_id': this.$store.state.modal.data.id,
                });
            },
            handleUpdateAdvisory() {
                this.$parentInfo.studentAdvisory.dialog_ShowAdvisory.button_loading = true;
                this.$wApi.send(this.$parentInfo.path, 'updateAdvisory', {
                    'advisory_id': this.$store.state.modal.data.id,
                    'content': this.$parentInfo.studentAdvisory.dialog_ShowAdvisory.advisoryDetail.content,
                    'grade_id': this.$parentInfo.studentAdvisory.dialog_ShowAdvisory.advisoryDetail.grade_id,
                    'subject_id': this.$parentInfo.studentAdvisory.dialog_ShowAdvisory.advisoryDetail.subject_id,
                    'status': this.$parentInfo.studentAdvisory.dialog_ShowAdvisory.advisoryDetail.status,
                    'impression': this.$parentInfo.studentAdvisory.dialog_ShowAdvisory.advisoryDetail.impression,
                    'classType_id': this.$parentInfo.studentAdvisory.dialog_ShowAdvisory.advisoryDetail.classType_id,
                    'student_id':this.$parentInfo.student_id,
                });
            },

        }
    }
</script>

<style scoped>

</style>
